import { useSearchParams } from 'react-router-dom';
import CopilotPage from './CopilotPage';

/**
 * This component acts as a wrapper around the main CopilotPage.
 * Its purpose is to read URL query parameters and pass them as props.
 */
export default function CopilotPageWrapper({ onLogout }) {
    const [searchParams] = useSearchParams();
    
    // Read all the required parameters from the URL
    const initialCustomerName = searchParams.get('customer');
    const initialCountryCode = searchParams.get('countrycode');
    const initialContactId = searchParams.get('contactid');

    // Render the main page, passing all the contextual info as props
    return (
        <CopilotPage 
            onLogout={onLogout} 
            initialCustomerName={initialCustomerName} 
            initialCountryCode={initialCountryCode}
            initialContactId={initialContactId}
        />
    );
}

